(() => {
  function uniq(arr) { return [...new Set(arr)]; }

  function getSelectedValue(group) {
    const select = group.querySelector('select');
    if (select) return select.value;

    const checked = group.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;

    // buttons 有些主題用 input hidden + aria-pressed 的 button
    const pressed = group.querySelector('[aria-pressed="true"][data-value]');
    if (pressed) return pressed.getAttribute('data-value');

    return null;
  }

  function setFirstValidIfInvalid(group) {
    const select = group.querySelector('select');
    if (select) {
      const current = select.value;
      const valid = [...select.options].find(o => !o.disabled && !o.hidden);
      if (!valid) return false;
      if (select.selectedOptions[0] && (select.selectedOptions[0].disabled || select.selectedOptions[0].hidden)) {
        select.value = valid.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      // 有值但不在清單（少見）
      if (current && select.value !== current) {
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      return false;
    }

    const checked = group.querySelector('input[type="radio"]:checked');
    if (checked && checked.disabled) {
      const first = group.querySelector('input[type="radio"]:not(:disabled)');
      if (first) {
        first.checked = true;
        first.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  function hideOrShowValue(group, value, ok) {
    // select dropdown
    const select = group.querySelector('select');
    if (select) {
      const opt = [...select.options].find(o => o.value === value);
      if (!opt) return;
      opt.disabled = !ok;
      opt.hidden = !ok;   // 直接消失
      return;
    }

    // radio / button style
    const input = group.querySelector(`input[type="radio"][value="${CSS.escape(value)}"]`);
    if (input) {
      input.disabled = !ok;
      const label = group.querySelector(`label[for="${CSS.escape(input.id)}"]`) || input.closest('label');
      const wrap = label || input.closest('.variant-option') || input.parentElement;
      if (wrap) wrap.style.display = ok ? '' : 'none'; // 直接消失
      return;
    }

    // aria-pressed button (若你主題用 button)
    const btn = group.querySelector(`[data-value="${CSS.escape(value)}"]`);
    if (btn) {
      btn.setAttribute('aria-disabled', (!ok).toString());
      btn.style.display = ok ? '' : 'none';
    }
  }

  function extractVariantsJSON(root) {
    // 優先找主題常見的 JSON script
    const script =
      root.querySelector('script[type="application/json"][data-variants-json]') ||
      root.querySelector('script[type="application/json"][id*="ProductJson"]') ||
      root.querySelector('script[type="application/json"][id*="product-json"]') ||
      root.querySelector('script[type="application/json"][id*="Variants"]');

    if (script) {
      try { return JSON.parse(script.textContent); } catch (e) {}
    }

    // Dawn 系列常見 custom element 方法
    const variantSelects = root.querySelector('variant-selects, variant-radios');
    if (variantSelects && typeof variantSelects.getVariantData === 'function') {
      try { return variantSelects.getVariantData(); } catch (e) {}
    }

    return null;
  }

  function getOptionGroups(root) {
    // 你可以先用這組泛用 selector；若抓不到，再把主題實際 class 補進來
    const groups = [...root.querySelectorAll('[data-option-position]')];
    if (groups.length) return groups;

    // fallback：Dawn 常見
    const dawn = [...root.querySelectorAll('fieldset.product-form__input, .product-form__input')];
    return dawn;
  }

  function getGroupPosition(group, indexFallback) {
    const pos = group.getAttribute('data-option-position');
    if (pos) return parseInt(pos, 10);
    const idx = group.getAttribute('data-option-index');
    if (idx) return parseInt(idx, 10) + 1;
    return indexFallback + 1; // 1-based
  }

  function getAllValues(group) {
    const select = group.querySelector('select');
    if (select) return [...select.options].map(o => o.value);

    const radios = [...group.querySelectorAll('input[type="radio"]')];
    if (radios.length) return radios.map(r => r.value);

    const btns = [...group.querySelectorAll('[data-value]')];
    if (btns.length) return btns.map(b => b.getAttribute('data-value'));

    return [];
  }

  function prune(root) {
    const variants = extractVariantsJSON(root);
    if (!variants || !Array.isArray(variants) || !variants.length) return;

    const groups = getOptionGroups(root);
    if (!groups.length) return;

    // 依照 option1 -> option2 -> option3 逐層過濾
    const selected = [];
    groups.forEach((g, i) => {
      const v = getSelectedValue(g);
      selected[i] = v;
    });

    groups.forEach((group, i) => {
      const pos = getGroupPosition(group, i); // 1,2,3...
      if (pos === 1) return;

      const prefix = selected.slice(0, pos - 1).filter(v => v != null);
      // 若前面還沒選完，就先不要砍（可依需求改成也砍）
      if (prefix.length < pos - 1) return;

      const validSet = new Set(
        variants
          .filter(v => {
            if (!v.options) return false;
            for (let k = 0; k < pos - 1; k++) {
              if (v.options[k] !== prefix[k]) return false;
            }
            return true;
          })
          .map(v => v.options[pos - 1])
      );

      const all = uniq(getAllValues(group)).filter(v => v !== '' && v != null);
      all.forEach(val => hideOrShowValue(group, val, validSet.has(val)));

      // 如果目前已選值被砍掉，改選第一個合法值，並觸發後續更新
      setFirstValidIfInvalid(group);
    });
  }

  function init() {
    // 盡量縮小範圍：只針對商品頁的 product form / product section
    const roots = document.querySelectorAll('main, .shopify-section, form[action*="/cart/add"]');
    roots.forEach(r => prune(r));

    document.addEventListener('change', (e) => {
      const t = e.target;
      if (!t) return;
      // 只要是 variant picker 相關的 input/select 變動就重算
      if (t.matches('select[name^="options"], input[type="radio"][name^="options"], variant-selects *, variant-radios *')) {
        const root = t.closest('main, .shopify-section, form[action*="/cart/add"]') || document;
        prune(root);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();






(function () {
  let moheVariantUpdating = false;

  function mohePruneMobileDropdowns() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    if (moheVariantUpdating) return;

    document
      .querySelectorAll('[data-product-form-variant-container]')
      .forEach(function (container) {

        const json = container.querySelector('[data-variants-json]');
        if (!json) return;

        let variants;

        try {
          variants = JSON.parse(json.textContent);
        } catch (e) {
          console.warn('mohe variant JSON error', e);
          return;
        }

        /*
         * 每一個 fieldset 都有：
         * data-option-position="1"
         * data-option-position="2"
         * ...
         */
        const fieldsets = Array.from(
          container.querySelectorAll(
            '.product-variant-picker-block[data-option-position]'
          )
        );

        fieldsets.forEach(function (fieldset) {

          const position = parseInt(
            fieldset.dataset.optionPosition,
            10
          );

          /*
           * 第一層是顏色色票，不處理
           */
          if (position <= 1) return;

          const select = fieldset.querySelector('select');
          if (!select) return;

          /*
           * 保存 Shopify 原始的完整選項
           */
          if (!select._moheOriginalOptions) {
            select._moheOriginalOptions =
              Array.from(select.options).map(function (option) {
                return {
                  value: option.value,
                  text: option.textContent,
                  handle: option.dataset.handle || ''
                };
              });
          }

          /*
           * 取得前面已選的 option
           */
          const selectedPrevious = [];

          for (let p = 1; p < position; p++) {

            const previousFieldset =
              container.querySelector(
                '[data-option-position="' + p + '"]'
              );

            if (!previousFieldset) return;

            const previousSelect =
              previousFieldset.querySelector('select');

            if (previousSelect) {
              selectedPrevious[p - 1] =
                previousSelect.value;
            } else {
              const checked =
                previousFieldset.querySelector(
                  'input[data-single-option-selector]:checked'
                );

              if (checked) {
                selectedPrevious[p - 1] =
                  checked.value;
              }
            }
          }

          /*
           * 找出符合前面條件，
           * 而且實際可以購買的 variants
           */
          const validValues = new Set();

          variants.forEach(function (variant) {

            if (!variant.available) return;

            let match = true;

            for (let p = 0; p < position - 1; p++) {

              if (
                selectedPrevious[p] &&
                variant.options[p] !== selectedPrevious[p]
              ) {
                match = false;
                break;
              }
            }

            if (match && variant.options[position - 1]) {
              validValues.add(
                variant.options[position - 1]
              );
            }
          });

          /*
           * 如果完全找不到，不要清空 Dropdown
           */
          if (validValues.size === 0) {
            return;
          }

          const oldValue = select.value;

          select.innerHTML = '';

          /*
           * 只把目前真的可以選的項目放回去
           */
          select._moheOriginalOptions.forEach(
            function (original) {

              if (!validValues.has(original.value)) return;

              const option =
                document.createElement('option');

              option.value = original.value;
              option.textContent = original.text;

              if (original.handle) {
                option.dataset.handle =
                  original.handle;
              }

              select.appendChild(option);
            }
          );

          /*
           * 原本選項仍有效就保留
           */
          if (validValues.has(oldValue)) {

            select.value = oldValue;

          } else if (select.options.length > 0) {

            /*
             * 如果原本選的是已失效的組合，
             * 改成第一個有效選項
             */
            const newValue =
              select.options[0].value;

            select.value = newValue;

            moheVariantUpdating = true;

            setTimeout(function () {
              select.dispatchEvent(
                new Event('change', {
                  bubbles: true
                })
              );

              setTimeout(function () {
                moheVariantUpdating = false;
              }, 50);

            }, 0);
          }

        });

      });
  }


  function runMohePrune() {
    setTimeout(
      mohePruneMobileDropdowns,
      100
    );

    setTimeout(
      mohePruneMobileDropdowns,
      350
    );
  }


  document.addEventListener(
    'DOMContentLoaded',
    runMohePrune
  );


  document.addEventListener(
    'change',
    function (event) {

      if (
        event.target.closest(
          '[data-product-form-variant-container]'
        )
      ) {
        runMohePrune();
      }

    }
  );

})();
